import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingCircular() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 3,
      }}
    >
      <CircularProgress />
      <Typography sx={{ ml: 2, fontSize: 18 }}>Loading...</Typography>
    </Box>
  );
}
